const fontSizes = require("./cabin-font-sizes.json");

export const estTextWidth = (text, weight, size) => {
    if (text == null) {
        return null;
    }
    const sizes = fontSizes[weight];
    let ret = 0;
    for (let i = 0; i < text.length; i++) {
        const c = text[i];
        ret += (sizes[c] || sizes[" "]) + 5;
    }
    return ret * size / 100;
};
